import getConfig from 'config/web'

const paths = getConfig()

export default paths
